<template>
  <article class="motion">
    <!--
    <div style="max-height:100px;">
      <div v-resize-text>{{motion.name}}</div>
    </div>
    -->
    <header class="p-d-flex p-jc-center p-ai-center">
      <div class="flex-grow-1">
        <h1>{{motion.name}}</h1>
      </div>
      <div class="motion-status">
        <motion-state-display :state="motion.state" :reason="motion.stateReason" :hide-if-pending="true"/>
      </div>
    </header>
    <!--<h2 v-if="motion.hasParent()">{{motion.parent.name}}</h2>-->
    <div class="p-grid">
      <div class="p-col">
        <div class="p-grid prop-sec p-mt-1">
          <div class="p-col">
            <h4>Proposer</h4>
          </div>
          <div class="p-col p-ai-start">
            <div v-if="motion.hasProposer()">
              <span v-if="motion.proposer.getName()">
                <strong>{{motion.proposer.getName()}}</strong>
              <br/>
              </span>
              {{motion.proposer.associationName}}
              <speaker-state-display
                v-if="motion.proposerState && showSpeakerState"
                :state="motion.proposerState"/>
            </div>
            <div v-else class="empty-state">
              -
            </div>
          </div>
          <div class="p-col"></div>
        </div>
      </div>
      <div class="p-col">
        <div class="p-grid prop-sec p-mt-1">
          <div class="p-col">
            <h4>Seconder</h4>
          </div>
          <div class="p-col">
            <div v-if="motion.hasSeconder()">
              <span v-if="motion.seconder.getName()">
                <strong>{{motion.seconder.getName()}}</strong>
              <br/>
              </span>
              {{motion.seconder.associationName}}
              <speaker-state-display
                v-if="motion.seconderState && showSpeakerState"
                :state="motion.seconderState"/>
            </div>
            <div v-else class="empty-state">
              -
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-grid for-against">
      <div class="p-col">
        <h4>For</h4>
        <speakers-table :speakers="motion.for" :show-state="showSpeakerState"/>
      </div>
      <div class="p-col">
        <h4>Against</h4>
        <speakers-table :speakers="motion.against" :show-state="showSpeakerState"/>
      </div>
    </div>
  </article>
</template>

<script>
import SpeakersTable from '../speakers/SpeakersTable.vue'
import SpeakerStateDisplay from '../speakers/SpeakerStateDisplay.vue'
import MotionStateDisplay from './MotionStateDisplay.vue'

export default {
  name: 'MotionView',
  components: {
    SpeakersTable,
    SpeakerStateDisplay,
    MotionStateDisplay
  },
  props: {
    motion: {
      type: Object,
      required: true
    },
    showSpeakerState: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 2.5rem;
  margin-top: 0rem;
  margin-bottom: 0.5rem;
}
.motion-state {
  font-size: 1.5rem;
  font-weight: bold;
}
.prop-sec h4 {
  margin-top: 0;
}
.for-against h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/motions/MotionView.vue